<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper">

    <app-header></app-header>

    <app-sidebar></app-sidebar>

    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">

        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div class="container-fluid">

            <app-breadcrumbs></app-breadcrumbs>

            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->

            <router-outlet></router-outlet>

            <!-- 
          <div class="row">
              <div class="col-12">
                  <div class="card">
                      <div class="card-body">
                          This is some text within a card block.
                      </div>
                  </div>
              </div>
          </div> 
      -->
            <app-setting></app-setting>
            <!-- ============================================================== -->
            <!-- End Page Content -->
            <!-- ============================================================== -->

            <!-- Right sidebar -->
            <!-- ============================================================== -->
            <!-- .right-sidebar -->

            <!-- ============================================================== -->
            <!-- End Right sidebar -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <img src="/opt/app/factelectback/files/logoPT2.png" alt="" style="position: absolute; right: 22px; bottom: 23px; width: 15%; opacity: 0.5;" (error)="$event.target.style.display='none'" />

    </div>
    <!-- ============================================================== -->
    <!-- END Page wrapper  -->
    <!-- ============================================================== -->

</div>

<!-- Modal Upload -->